import 'assets/styles/compliance.scss';

import React, { useEffect, useState, useRef } from 'react';

import SwapHorizontalCircleOutlinedIcon from '@material-ui/icons/SwapHorizontalCircleOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { useStore } from "../../hooks";
import { useSnackbar } from "notistack";
import * as config from "config/constants";
import { getAuthenticatedVideoUrl } from "../../services/youtube-api";

const RegChangeManagement = () => {
  const history = useHistory();
  const [microRegulatoryProcessNext, setMicroRegulatoryProcessNext] = useState('');
  const [microRegulatoryProcessData, setMicroRegulatoryProcessData] = useState();
  const [microRegulatoryProcessCount, setMicroRegulatoryProcessCount] = useState(0);
  const [microRegulatoryProcessDisplayCount, setMicroRegulatoryProcessDisplayCount] = useState(0);
  const [microRegulatoryProcessLoading, setMicroRegulatoryProcessLoading] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(true); // Auto-open on component load
  const [isVideoExpanded, setIsVideoExpanded] = useState(false);
  const [videoPosition, setVideoPosition] = useState({ x: 0, y: 0 }); // Will be set after categories-list is positioned
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [videoUrl, setVideoUrl] = useState('');
  const categoriesListRef = useRef(null);
  const store = useStore();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => { }, []);
  const numRecordPage = config.pageSize;

  const getMicroRegulatoryProcessList = async () => {
    try {
      const { data } = await store.api.getMicroProcessesRead();
      setMicroRegulatoryProcessData(data.results);
      setMicroRegulatoryProcessNext(data.next);
      setMicroRegulatoryProcessCount(data.count);
      data.count > numRecordPage
        ? setMicroRegulatoryProcessDisplayCount(numRecordPage)
        : setMicroRegulatoryProcessDisplayCount(data.count);
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    }
  };
  const getNextMicroRegulatoryProcesses = async () => {
    try {
      setMicroRegulatoryProcessLoading(true);
      const { data } = await store.api.getNextDataWithURL(microRegulatoryProcessNext);
      let newMicroRegulatoryProcesses = microRegulatoryProcessData;
      setMicroRegulatoryProcessNext(data.next);
      setMicroRegulatoryProcessData(undefined);
      const arrayLength = data.results.length;
      data.results.map((process, i) => {
        newMicroRegulatoryProcesses.push(process);
        if (arrayLength === i + 1) {
          setMicroRegulatoryProcessData(newMicroRegulatoryProcesses);
          setMicroRegulatoryProcessDisplayCount(microRegulatoryProcessDisplayCount + arrayLength);
        }
      });
    } catch (error) {
      setMicroRegulatoryProcessLoading(false);
      console.log(error);
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setMicroRegulatoryProcessLoading(false);
    }
  };

  useEffect(() => {
    getMicroRegulatoryProcessList();
  }, []);

  // Position video window over categories-list right corner
  useEffect(() => {
    if (categoriesListRef.current) {
      const rect = categoriesListRef.current.getBoundingClientRect();
      setVideoPosition({
        x: rect.right - 320, // 300px width + 20px margin
        y: rect.top + 20
      });
    }
  }, [microRegulatoryProcessData]); // Re-position when data loads

  // Function to get video URL with authentication
  const getVideoUrl = async () => {
    try {
      const authenticatedUrl = await getAuthenticatedVideoUrl('uU0j_lStuOI');
      setVideoUrl(authenticatedUrl);
    } catch (error) {
      console.error('Error fetching video URL:', error);
      // Fallback to public embed URL
      setVideoUrl('https://www.youtube.com/embed/uU0j_lStuOI');
    }
  };

  // Load video URL on component mount
  useEffect(() => {
    getVideoUrl();
  }, []);

  const navigateToMicroRegulatoryProcess = (microProcessId) => {
    const path = 'user-micro-regulatory-process-detail?micro_process=' + microProcessId;
    history.push(path);
  };

  // Drag handlers for video window
  const handleMouseDown = (e) => {
    setIsDragging(true);
    const rect = e.currentTarget.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setVideoPosition({
        x: e.clientX - dragOffset.x,
        y: e.clientY - dragOffset.y
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Add global mouse event listeners
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, dragOffset]);


  return (
    <section className={'compliance-container'}>
      <div className="back-nav" onClick={() => history.push('/companies-dashboard')}>
        Home
      </div>
      <SwapHorizontalCircleOutlinedIcon
        style={{
          width: '42px',
          height: '42px',
          color: '#e0123c',
          fontSize: 'large',
          position: 'absolute',
        }}
      />
      <h4 style={{ cursor: 'pointer' }}>Regulations and Operations Change Management Dashboard</h4>

      {/* Draggable video window */}
      <div
        style={{
          position: 'fixed',
          left: `${videoPosition.x}px`,
          top: `${videoPosition.y}px`,
          width: '300px',
          height: '200px',
          border: '2px solid #ccc',
          borderRadius: '4px',
          overflow: 'hidden',
          zIndex: 1000,
          cursor: isDragging ? 'grabbing' : 'grab',
          backgroundColor: '#fff',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
        }}
        onMouseDown={handleMouseDown}
        onClick={(e) => {
          if (!isDragging) {
            setIsVideoExpanded(true);
          }
        }}
      >
        <iframe
          width="300"
          height="200"
          src={videoUrl || 'https://www.youtube.com/embed/uU0j_lStuOI'}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ pointerEvents: 'none' }}
        />
      </div>

      {/* Expanded video modal */}
      <Dialog
        open={isVideoExpanded}
        onClose={() => setIsVideoExpanded(false)}
        aria-labelledby="expanded-video-title"
        PaperProps={{
          style: {
            width: '60vw',
            height: '60vh',
            maxWidth: '60vw',
            maxHeight: '60vh',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle id="expanded-video-title">Regulations and Operations Change Management Video</DialogTitle>
        <DialogContent style={{ height: '100%', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: '90%', height: '90%' }}>
            <iframe
              style={{ width: '100%', height: '100%' }}
              src={videoUrl || 'https://www.youtube.com/embed/uU0j_lStuOI'}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsVideoExpanded(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <ul className="categories-list" ref={categoriesListRef}>
        <li key="count" style={{ backgroundColor: '#f4f5f7' }}>
          <div>
            <div>This screen lists all Regulatory Micro-processes that have been assigned a process owner but have not completed their first Compliance Monitoring Programme as so are therefore not live.</div>
            <div>&nbsp;</div>
            <div><strong>ACTION</strong>:&nbsp; Process Owners will be responsible for Reviewing and Signing off the Risk Assessment, Policy, Procedures documents, uploading the applicable Evidence Files/Reports and completing the first Compliance Monitoring Programme.&nbsp;</div>
            <div><br clear="all" />
              <div><strong>RESULT</strong>: The execution of the first Compliance Monitoring Programme will result in the Regulatory Micro-process "GOING LIVE". This means it will be part of the on-going Compliance Monitoring and appear in the Micro-process owner's Management Dashboard for approval, and the scheduled Next Review Date. The Next Reviewed Date is calculated from the date the process finished it's last Compliance Monitoring Programme, taking into account the Next Review Date Frequency (e.g. Monthly).</div>
            </div>
          </div>
          <p>&nbsp;</p>
          <span>
            Displaying {microRegulatoryProcessDisplayCount} of {microRegulatoryProcessCount} Micro
            Regulatory Processes
          </span>
        </li>
        {microRegulatoryProcessData !== undefined &&
          microRegulatoryProcessData.map((microProcess, i) => {
            const microProcessId = microProcess.id;

            return (
              <li key={i} onClick={() => navigateToMicroRegulatoryProcess(microProcessId)}>
                <span>{microProcessId}</span>
                <span className="title-spacing">{microProcess.micro_regulatory_process.name}</span>
                <div className="status-text">
                  <span className="owner"> Owner: {microProcess.owner.first_name} {microProcess.owner.last_name}</span>
                  <span className="last-updated">Last Updated At {microProcess.last_updated}</span>
                </div>
                {microProcess.validation_status === 'Passed' ? (
                  <div className="status green-status"></div>
                ) : (
                  <div className="status red-status"></div>
                )}
              </li>
            );
          })}
        {microRegulatoryProcessCount > 10 && (
          <li className="get-next" key="next" onClick={() => getNextMicroRegulatoryProcesses()}>
            <span>{microRegulatoryProcessLoading ? 'Loading...' : 'Load ' + numRecordPage.toString() + ' more'}</span>
          </li>
        )}
      </ul>
    </section>
  );
};
RegChangeManagement.defaultProps = {};

export default RegChangeManagement;
